module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8706/img/favicon-dark.png"